import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/people-taking-care-plants-outdoors_23-2148978508.jpg';

function CommunityDevelopmentRevitalization() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Community Development and Revitalization" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Community Development and Revitalization</h4>
              <p>
                This sub-department focuses on enhancing urban and rural areas through economic development and neighborhood improvement initiatives.<br />
                Programs include public infrastructure projects, small business support, and revitalization efforts for underdeveloped communities.<br /><br />
                By fostering growth and revitalization, we aim to create vibrant, sustainable communities for residents and businesses alike.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Public Infrastructure Improvements</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Small Business Development Support</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Revitalization of Underserved Areas</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to building stronger, more resilient communities through comprehensive development and revitalization efforts.
              </p>
            </div>
            <div>
              <Link to="/department/housing">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default CommunityDevelopmentRevitalization;
